<nav class='assumed-location-banner hidden-sm hidden-xs' *ngIf="selectedLocation">
  <div class="banner-container container-constraint">
    <div class="locImageContainer"><img src="../../../../assets/images/menu/location_icon.svg" alt="location icon">
    </div>
    <div class="selLocRow">
      <div class="selLoc pull-right">Selected Location</div>
      <div class="locNickName pull-right">{{selectedLocation?.nickName}} <span
          class="locDistanceUnit">{{selectedLocation?.distanceStr}}</span></div>
    </div>
    <button aria-label="Change Location" class="banner-btn pull-right " (click)="changeLocation()">Change</button>
  </div>
</nav>
<nav role="button" aria-label="Change Location" class='assumed-location-banner hidden-md hidden-lg' (click)="changeLocation()"
  *ngIf="selectedLocation">
  <div class="locImageContainer"><img src="../../../../assets/images/menu/location_icon.svg" alt="location icon"></div>
  <div class="selLocRow">
    <div class="selLoc">Selected Location</div>
    <div class="flex-parent">
      <div class="flex-child locNickName">{{selectedLocation?.nickName}}</div>
      <div class="locDistanceUnit">{{selectedLocation?.distanceStr}}</div>
    </div>
  </div>
</nav>
